import { AccordionStep } from '@hb/domain';

import { InjectionToken, Type } from '@angular/core';

import { AvailableIcons } from '@ap/icon';

export interface AccordionStepConfig {
    step: AccordionStep;
    titleKey: string;
    component: Type<unknown>;
    icon: AvailableIcons;
}

export const ACCORDION_STEPS_CONFIG = new InjectionToken<AccordionStepConfig[]>('ACCORDION_STEPS_CONFIG');
